import { NotFoundContentLoadable } from '#/components/NotFoundContent/NotFoundContentLoadable';

export async function loader() {
  await NotFoundContentLoadable.load();
}

export default function UserDashboardNotFoundHorizonRoute() {
  return <NotFoundContentLoadable textOnly />;
}
